var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": 900, grow: "" } },
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.$ct("price-wizard")) + " "),
          _c("w-spacer"),
          _c(
            "w-link",
            {
              attrs: { white: "" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "times" } })],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-content",
        [
          _c("w-tabs", {
            staticClass: "mb",
            attrs: { tabs: _vm.tabNames },
            model: {
              value: _vm.selectedTab,
              callback: function ($$v) {
                _vm.selectedTab = $$v
              },
              expression: "selectedTab",
            },
          }),
          _c("app-product-edit-sell-price-modal-starting-price", {
            attrs: {
              value: _vm.selectedPrice.AbsolutePriceRule,
              "selected-price-category": _vm.selectedPricateCategory,
            },
          }),
          _c("app-product-edit-sell-prices-modal-interest", {
            attrs: { value: _vm.selectedPrice },
          }),
          _c("app-price-category-discount-edit", {
            attrs: { value: _vm.selectedPrice },
          }),
          _c("app-price-category-sales-dates-edit", {
            attrs: {
              product: _vm.product,
              "price-category": _vm.selectedPricateCategory + 1,
            },
          }),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                [
                  _c("w-checkbox", {
                    attrs: { label: _vm.$ct("sales-dates-overwrite") },
                    model: {
                      value: _vm.OverwriteAllValues,
                      callback: function ($$v) {
                        _vm.OverwriteAllValues = $$v
                      },
                      expression: "OverwriteAllValues",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.cancel")) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "save" },
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.save")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }